import { type BoxProps } from "@chakra-ui/react";
import React from "react";
import { VideoModal, type VideoModalProps, VideoWrapper } from "ui/video";

const videoShort = "https://cdn.sanity.io/files/pwmfmi47/production/c60241a04792ecc01e0884b70187451338c5d360.mp4";
const videoSrc = "https://cdn.sanity.io/files/pwmfmi47/production/0b856dfbcd7b7a6fd5602d789a6ea7b058a376da.mp4";
const videoCaptions = "/assets/platform/agents/agents-founder-captions.vtt";
const videoThumbnail =
  "https://cdn.sanity.io/images/pwmfmi47/production/d05e7a1adae42054a68b6d23053994427f614417-1182x652.webp";

type AgentsVideoProps = Pick<VideoModalProps, "hasPlayButton" | "clickableSpace" | "isOpen" | "onOpen" | "onClose"> &
  BoxProps;

export function AgentsVideo({ hasPlayButton, clickableSpace, isOpen, onOpen, onClose, ...props }: AgentsVideoProps) {
  return (
    <VideoWrapper {...props}>
      <VideoModal
        hasPlayButton={hasPlayButton}
        iconTheme="dark"
        shortSrc={videoShort}
        src={videoSrc}
        captions={videoCaptions}
        thumbnail={videoThumbnail}
        clickableSpace={clickableSpace}
        uploadDate="November 12, 2025"
        videoId="agents-founder-video"
        title="Discover Hightouch Agents with Kashish and Tejas"
        description="Discover Hightouch Agents — the AI platform built for marketers to launch campaigns 10x faster, brainstorm ideas, and automate strategy effortlessly."
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
    </VideoWrapper>
  );
}
